import Router from 'next/router';
import { Locales } from '../constants';

export const getIsPathnameRouterLocale = (pathname?: string): boolean => {
  const urlLocale = Object.values(Locales).find((locale) => pathname?.startsWith('/' + locale));

  return !urlLocale || urlLocale === Router.locale;
};
